// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__zNfj9","errors":"Errors_errors__2xu_f"};